
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlists/[module]",
      function () {
        return require("private-next-pages/playlists/[module].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlists/[module]"])
      });
    }
  